module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logos) ? _c('div', {
    staticClass: "cards-container"
  }, [_c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.logos), function(logo) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "img-container",
      style: ({
        'background-image': 'url(\'' + logo.url + '\')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "name-container"
    }, [_c('span', [_vm._v(_vm._s(logo.name))])])])
  })), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.fetching
    },
    on: {
      "click": _vm.fetchLogos
    }
  }, [(!_vm.fetching) ? _c('span', [_vm._v("Show More")]) : _vm._e(), _vm._v(" "), (_vm.fetching) ? _c('span', [_c('i', {
    staticClass: "fas fa-globe fa-spin"
  })]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-207712ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/LogoWall.vue
// module id = 656
// module chunks = 0